var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1050 1050",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=empty_search, Error=False"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M344.017 470.849C396.47 487.258 446.085 548.45 464.419 577.113C464.466 577.188 464.465 577.278 464.42 577.354C464.283 577.588 464.591 577.835 464.792 577.653C481.522 562.488 502.426 552.865 525.102 552.865C548.24 552.865 569.533 562.884 586.429 578.587C587.053 579.166 588.111 578.345 587.68 577.61C587.543 577.377 587.541 577.099 587.687 576.871C606.144 548.107 655.627 487.212 707.934 470.849C756.458 455.669 813.907 460.74 842.031 466.096C845.209 466.701 846.749 470.244 845.065 473.006C827.28 502.187 787.018 555.176 743.905 571.659C703.426 587.134 643.949 592.943 610.088 594.357C606.175 594.521 603.947 599.045 606.033 602.359C617.696 620.889 624.56 642.692 624.56 664.258C624.56 671.235 623.642 677.851 621.952 684.086C621.495 685.772 621.912 687.581 623.071 688.888C633.722 700.908 639.86 714.711 639.86 728.829C639.86 769.674 574.193 797.685 525.101 797.685C476.008 797.685 410.341 769.674 410.341 728.829C410.341 714.71 416.48 700.906 427.132 688.886C428.291 687.579 428.708 685.77 428.251 684.084C426.562 677.85 425.644 671.234 425.644 664.258C425.644 642.66 432.528 620.825 444.221 602.279C446.305 598.973 444.098 594.46 440.195 594.285C406.078 592.752 347.868 586.883 308.046 571.659C264.933 555.176 224.671 502.187 206.885 473.006C205.202 470.244 206.741 466.701 209.919 466.096C238.043 460.74 295.493 455.669 344.017 470.849Z",
    fill: "url(#paint0_linear_143_3771)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M29.6309 481.68V490.211",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M10.4766 486.302L17.4482 493.479",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M2.31738 505.408H12.1751",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M9.67383 524.852L16.6454 517.675",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M29.6309 527.181V518.649",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M43.8499 521.494L38.1621 515.806",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M55.228 507.273H46.6963",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M49.5423 487.366L43.8545 493.054",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M487.5 109.128V114.816",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M470.44 126.191H476.128",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M487.5 143.256V137.568",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M501.725 126.191H496.037",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M157.605 348.013V356.545",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M132.018 373.61H140.549",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M157.605 396.362V387.83",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M180.361 373.61H171.829",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M769.767 658.115C776.564 658.115 782.076 663.628 782.076 670.426C782.076 677.227 776.564 682.738 769.767 682.738C762.971 682.738 757.459 677.227 757.459 670.426",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 24",
    d: "M825.949 819.958C827.47 830.575 820.102 840.413 809.491 841.935C798.877 843.454 789.041 836.083 787.52 825.469C785.999 814.855 793.368 805.017 803.979 803.495",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.099 546.418C833.407 544.139 844.609 535.201 847.202 525.584C849.554 534.085 859.412 544.139 868.306 544.899C858.294 548.445 848.721 558.976 847.202 567.25C846.169 558.817 832.929 547.648 826.099 546.418Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9082 654.32C79.5635 653.181 85.1624 648.713 86.4589 643.905C87.6347 648.153 92.5624 653.181 97.0096 653.562C92.0047 655.332 87.2194 660.599 86.4589 664.736C85.9422 660.52 79.3221 654.934 75.9082 654.32Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.743 258.713C143.743 263.987 139.47 268.259 134.199 268.259C128.926 268.259 124.655 263.987 124.655 258.713C124.655 253.441 128.926 249.166 134.199 249.166C139.47 249.166 143.743 253.441 143.743 258.713Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M707.345 858.093C707.345 866.905 700.201 874.049 691.393 874.049C682.581 874.049 675.439 866.905 675.439 858.093C675.439 849.281 682.581 842.137 691.393 842.137C700.201 842.137 707.345 849.281 707.345 858.093Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1002 241.115C1002 248.106 996.337 253.772 989.35 253.772C982.36 253.772 976.696 248.106 976.696 241.115C976.696 234.124 982.36 228.458 989.35 228.458C996.337 228.458 1002 234.124 1002 241.115Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.107 832.239C322.107 836.647 318.536 840.218 314.13 840.218C309.726 840.218 306.155 836.647 306.155 832.239C306.155 827.832 309.726 824.26 314.13 824.26C318.536 824.26 322.107 827.832 322.107 832.239Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.365 197.381C317.365 202.655 313.092 206.928 307.821 206.928C302.551 206.928 298.277 202.655 298.277 197.381C298.277 192.109 302.551 187.835 307.821 187.835C313.092 187.835 317.365 192.109 317.365 197.381Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.807 920.597C554.708 922.917 547.883 919.853 545.563 913.755C543.242 907.655 546.304 900.825 552.405 898.507C558.501 896.186 565.326 899.248 567.647 905.348C569.969 911.449 566.905 918.276 560.807 920.597Z",
    stroke: "#D2D8DF",
    strokeWidth: 0.782823,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 4",
    cx: 469,
    cy: 637.022,
    rx: 7.65063,
    ry: 12.7511,
    fill: "#ABB4C4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 8",
    cx: 586.311,
    cy: 637.022,
    rx: 7.65063,
    ry: 12.7511,
    fill: "#ABB4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M611.634 607.261C615.469 595.896 644.457 556.246 658.472 537.842C688.301 496.737 757.569 474.213 709.67 476.743C672.371 478.713 610.282 545.847 581.687 581.832C580.334 583.535 580.312 585.918 581.652 587.63C591.379 600.047 608.09 617.768 611.634 607.261Z",
    fill: "url(#paint1_linear_143_3771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M440.329 607.261C436.494 595.896 407.506 556.246 393.491 537.842C363.662 496.737 294.394 474.213 342.293 476.743C379.592 478.713 441.681 545.847 470.276 581.832C471.628 583.535 471.651 585.918 470.31 587.63C460.584 600.047 443.873 617.768 440.329 607.261Z",
    fill: "url(#paint2_linear_143_3771)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 5",
    d: "M529.188 736.862C533.281 735.642 541.896 732.603 547.055 727.403C551.023 723.404 546.646 718.382 541.012 718.382H512.777C507.143 718.382 502.766 723.404 506.734 727.403C511.893 732.603 520.508 735.642 524.601 736.862C526.102 737.309 527.687 737.309 529.188 736.862Z",
    stroke: "#ABB4C4",
    strokeWidth: 2.55021,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 6",
    d: "M527.656 736.48C527.656 759.015 516.239 777.283 502.154 777.283",
    stroke: "#ABB4C4",
    strokeWidth: 2.55021,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 7",
    d: "M553.159 777.283C539.075 777.283 527.657 759.015 527.657 736.48",
    stroke: "#ABB4C4",
    strokeWidth: 2.55021,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 5",
    d: "M653.593 470.579C603.323 497.489 585.469 546.62 582.825 567.822C569.404 588.004 535.85 558.036 541.95 547.639C548.051 537.242 554.762 519.506 559.032 504.828C563.303 490.15 558.422 476.084 541.95 457.124C525.479 438.165 534.63 410.032 535.85 394.742C537.07 379.453 560.252 366.609 550.491 391.073C540.73 415.536 559.032 430.826 566.963 442.446C573.308 451.742 591.569 462.629 599.907 466.91C606.008 462.832 620.283 451.498 628.58 438.777C638.951 422.875 643.832 410.032 618.209 369.667C592.586 329.303 596.857 314.013 599.907 305.451C602.957 296.889 612.108 300.558 610.888 309.12C609.668 317.683 635.291 349.485 653.593 369.667C668.235 385.813 673.522 408.605 674.335 417.983C677.589 416.352 687.147 412.479 699.348 410.032C751.814 394.131 756.085 325.633 759.745 309.12C763.405 292.607 744.493 261.417 759.745 270.59C774.997 279.764 783.538 339.088 776.217 369.667C768.896 400.247 744.493 418.594 744.493 422.875C744.493 427.157 775.607 441.223 744.493 438.777C713.38 436.33 716.43 436.942 653.593 470.579Z",
    fill: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6",
    d: "M391.74 470.579C442.01 497.489 459.864 546.62 462.508 567.822C475.929 588.004 509.483 558.036 503.383 547.639C497.282 537.242 490.571 519.506 486.301 504.828C482.03 490.15 486.911 476.084 503.383 457.124C519.854 438.165 510.703 410.032 509.483 394.742C508.263 379.453 485.081 366.609 494.842 391.073C504.603 415.536 486.301 430.826 478.37 442.446C472.025 451.742 453.764 462.629 445.426 466.91C439.325 462.832 425.05 451.498 416.753 438.777C406.382 422.875 401.501 410.032 427.124 369.667C452.747 329.303 448.476 314.013 445.426 305.451C442.376 296.889 433.225 300.558 434.445 309.12C435.665 317.683 410.042 349.485 391.74 369.667C377.098 385.813 371.811 408.605 370.998 417.983C367.744 416.352 358.186 412.479 345.985 410.032C293.519 394.131 289.249 325.633 285.588 309.12C281.928 292.607 300.84 261.417 285.588 270.59C270.336 279.764 261.795 339.088 269.116 369.667C276.437 400.247 300.84 418.594 300.84 422.875C300.84 427.157 269.726 441.223 300.84 438.777C331.953 436.33 328.903 436.942 391.74 470.579Z",
    fill: "#EDF0F7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_3771",
    x1: 218.979,
    y1: 791.294,
    x2: 211.111,
    y2: 485.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_143_3771",
    x1: 578.062,
    y1: 592.891,
    x2: 637.895,
    y2: 446.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_143_3771",
    x1: 473.901,
    y1: 592.891,
    x2: 414.068,
    y2: 446.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/EmptySearch.dfa7b329b6ba3748b2420384ece46008.svg";
export { ForwardRef as ReactComponent };